import * as Brenda from '@fixtuur/brenda';
import * as Hooks from 'preact/hooks';
import { useDoraAssembleFurniture } from './useDoraAssembleFurniture/useDoraAssembleFurniture';

/**
 * Produce a renderable model for Brenda from whatever the current configuration is
 *
 * TODO: redo the dora assemble furniture logic properly and move it all to a more suitable location
 * (e.g. Backpack.Render.Furniture.fromConfiguration)
 */
export const useRenderableForCurrentConfiguration = (): {
    furniture: Brenda.Renderer.Furniture.Furniture | undefined;
    isLoading: boolean;
} => {
    const { furnitureTree, isLoading: isFurnitureTreeLoading } = useDoraAssembleFurniture();

    const { furniture, isLoading } = Hooks.useMemo(() => {
        if (!furnitureTree || isFurnitureTreeLoading) {
            return { isLoading: true };
        }

        return {
            furniture: Brenda.Renderer.Furniture.fromParticleTree(furnitureTree),
            isLoading: false,
        };
    }, [furnitureTree, isFurnitureTreeLoading]);

    return {
        furniture,
        isLoading,
    };
};
